import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import FileUploadBox from '../CustomComponents/FileUploadBox';

const MOCK_PARSED_DATA = {
    name: '',
    contract_id: '',
    start_date: '',
    end_date: '',
};

function UploadContract({ onParsed, onSkip }) {
    const [file, setFile] = useState(null);
    const [isParsing, setIsParsing] = useState(false);

    const handleParse = async () => {
        setIsParsing(true);
        try {
            await onParsed({ ...MOCK_PARSED_DATA, _fileName: file?.name ?? '', _file: file });
        } finally {
            setIsParsing(false);
        }
    };

    const handleSkip = () => {
        onSkip({ ...MOCK_PARSED_DATA });
    };

    return (
        <Stack spacing={4} sx={{ maxWidth: 600, mx: 'auto', mt: 6 }}>
            <Stack spacing={1}>
                <Typography variant='heavy' sx={{ fontSize: '24px' }}>
                    Upload Contract File
                </Typography>
                <Typography sx={{ color: 'subtext.main', fontSize: '14px' }}>
                    Upload a PDF contract to automatically extract key details, or skip to fill in manually.
                </Typography>
            </Stack>

            <FileUploadBox
                accept='application/pdf'
                acceptLabel='PDF'
                onFileChange={setFile}
            />

            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Button
                    variant='text'
                    color='inherit'
                    sx={{ color: 'subtext.main' }}
                    onClick={handleSkip}
                    disabled={isParsing}
                >
                    Skip — fill in manually
                </Button>

                <Box>
                    {isParsing ? (
                        <Stack direction='row' spacing={1.5} alignItems='center'>
                            <CircularProgress size={18} />
                            <Typography sx={{ fontSize: '14px', color: 'subtext.main' }}>
                                Parsing contract…
                            </Typography>
                        </Stack>
                    ) : (
                        <Button
                            variant='blueContained'
                            disabled={!file}
                            onClick={handleParse}
                        >
                            Parse &amp; Continue
                        </Button>
                    )}
                </Box>
            </Stack>
        </Stack>
    );
}

export default UploadContract;
